import { render, staticRenderFns } from "./c_home_menu.vue?vue&type=template&id=b5b406c6&scoped=true"
import script from "./c_home_menu.vue?vue&type=script&lang=js"
export * from "./c_home_menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b406c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/yunxiao/be-3sdnltdmmjqei95chipgpfz5/runner/__flow_work/__flow_builds/182a3969-2a32-4dff-94d8-cf1bbedf203a/workspace/crmeb-mer-admin_BNnv/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5b406c6')) {
      api.createRecord('b5b406c6', component.options)
    } else {
      api.reload('b5b406c6', component.options)
    }
    module.hot.accept("./c_home_menu.vue?vue&type=template&id=b5b406c6&scoped=true", function () {
      api.rerender('b5b406c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfig/c_home_menu.vue"
export default component.exports